<p-button
    icon="pi pi-play"
    [rounded]="true"
    [text]="true"
    [disabled]="isReadonly"
    [pTooltip]="l('::Execute')"
    tooltipPosition="right"
    (onClick)="onClick()">    
</p-button>